"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ckeditor_module_1 = require("./ckeditor.module");
exports.CKEditorModule = ckeditor_module_1.CKEditorModule;
var ckeditor_component_1 = require("./ckeditor.component");
exports.CKEditorComponent = ckeditor_component_1.CKEditorComponent;
var ckbutton_directive_1 = require("./ckbutton.directive");
exports.CKButtonDirective = ckbutton_directive_1.CKButtonDirective;
var ckgroup_directive_1 = require("./ckgroup.directive");
exports.CKGroupDirective = ckgroup_directive_1.CKGroupDirective;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-ckeditor/lib/index.js
// module id = 980
// module chunks = 2